<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import { parseTime } from "@/utils/index";
import resize from "@/components/chart/mixins/resize";
let colorList = [
  {
    c1: "rgba(13, 255, 169, 0.4)",
    c2: "rgba(13, 255, 169, 0)",
    line: "rgba(13, 255, 169, 1)"
  },
];
let totalNum = 0;
let dataTime = '';
let chartVm = null;
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    id: {
      type: String,
      default: "chart1",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
    },
    unit: {
      type: String,
      default: "亩",
    }
  },
  data() {
    return {
      chart: null,
      options: {
        tooltip: {
          position: function (pos, params, dom, rect, size) {
              // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
              let obj = {top: 60};
              obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
              return obj;
          },
          trigger: "axis",
          textStyle: {
            color: '#fff',
          },
          borderColor: 'rgba(10, 69, 31, 0.8)',
          backgroundColor: 'rgba(10, 69, 31, 0.8)',
          axisPointer: {
            type: "cross",
            label: {
              color: '#ffffff',
              backgroundColor: "rgba(10, 69, 31, 0.8)",
              formatter(params) {
                if(params.axisDimension == 'y') return params.value.toFixed(2);
                else return parseTime(params.value,'{m}月{d}日',false)
              }
            },
          },
          formatter(params) {
            let dom = '';
            params.map((v,i)=>{
              if(v.seriesName == '作业量') v.marker = `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgba(13, 198, 255, 1);"></span>`;
              dom+= `
              <div style="margin: 0px 0 10px;line-height:1;display: flex;align-items: center;">
                  <span style="font-size:14px;color:#fff;font-weight:400;margin-left:2px">${v.seriesName || '--'}:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900">${v.value || '0'}${chartVm.unit || '亩'}</span>
                  </div>
                </div>
                <div style="margin: 0px 0 10px;line-height:1;">
                  <span style="font-size:14px;color:#fff;font-weight:400;margin-left:2px">占比:</span>
                    <span style="float:right;margin-left:20px;font-size:14px;color:#fff;font-weight:900">${v.value&&Number(v.value)>0&&totalNum>0?((Number(v.value) / totalNum) * 100).toFixed(2): 0}%</span>
                  </div>
                </div>
              `
            });
            let topDom = params && params.length>0 ? `<div style="font-size:14px;color:#fff;font-weight:400;line-height:1;margin-bottom: 10px">${params[0].axisValueLabel}</div>`:''
            return `<div>${topDom}${dom}</div>`;
          }
        },
        legend: {
          show: true,
          orient: "horizontal",
          x: "90",
          y: "5",
          itemWidth: 16,
          itemHeight: 16,
          textStyle: {
            color: "#62D9AD",
            fontSize: 12,
          },
          formatter(params) {
            return `${parseTime(dataTime,'{m}月',false)}${params}`
          }
        },
        grid: {
          right: "10px",
          left: "17.5%",
          top: "21.5%",
          bottom: "14.5%"
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 1
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          axisLabel: {
            show: true,
            margin: 10,
            fontSize: 12,
            rotate: -0,
            interval: 2,
            showMaxLabel: true,
            textStyle: {
              color: '#ffffff' //X轴文字颜色
            },
            formatter(params) {
              return parseTime(params,'{d}')
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(13, 255, 169, 0.1)'
            },
            width: 5
          },
          data: [],
        },

        yAxis: {
          minInterval: 1,
          name: `单位(${this.unit || '亩'})`,
          type: "value",
          nameTextStyle: {
            color: "#62D9AD",
            fontSize: 12,
            align: 'right'
          },
          axisLabel: {
            interval: 0,
            color: "#ffffff",
            fontSize: 12,
            rotate: 30,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#62D9AD",
            },
            width: 50,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "rgba(13, 255, 169, 0.1)",
            },
          },
        },
        series: [],
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    chartVm = this;
    this.initChart();
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    getSum(arr) {
      totalNum = 0;
      arr.map(item => {
        totalNum += Number(item)
      })
      return totalNum
    },
    setChartData() {
      this.options.yAxis.name = `单位(${this.unit || '亩'})`;
      let series = [];
      this.getSum(this.chartData.barList);
      if (this.chartData.barList) {
        series.push({
          name: `作业量`,
          type: "line",
          smooth: 0.2,
          symbol: "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjFEQjZCMTkzMUZCRTExRUU5N0RFRTdENEI2MENCNDhCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjFEQjZCMTk0MUZCRTExRUU5N0RFRTdENEI2MENCNDhCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MURCNkIxOTExRkJFMTFFRTk3REVFN0Q0QjYwQ0I0OEIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MURCNkIxOTIxRkJFMTFFRTk3REVFN0Q0QjYwQ0I0OEIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4F5N32AAABYklEQVR42oyTP0tDMRTF3wsoFP8MoujqGytu+h1qrXbTD9CCQrvUrdTRrrpUUFBXBUfb0qHgB2jH6iIIThYsiloR3qLnwAk8pdYEfiTc5Jxccm/8iccj79eIgyxYAfOK3YMGOAG30cMmsh4FFdAEPbABpsSmYtzjjTEr8pUBxTXwrNvfvcFjHJyCaWUYWoNDMKObvt7mttYwF8CyhC2wP9k9rvJScAGeQJ4GC1jUAec+xHuYS39kUIbJrjK5AUmjlCsSp4aIOUrKri9NlgYJUNWBHe//UdBMTYIGAbhTcMnBwJ6hJrBlHPHchx/RhEZNEijYdjBoaabmwajDkgoeOBjYM9Q0jRojz9KgRFcs1RBxWWfGQI6tTYOOXpRGvuqcBtfgQ3C9rj2+wZk6tzOolTOqs1Mr2yqEYFXtyQ4rgkV9mpjWRe29gJQ0P35jqLfg48yCS/Aq03PFeMk2+LSibwEGAHaQZOueYtloAAAAAElFTkSuQmCC",
          symbolSize: 16,
          itemStyle: {
            normal: {
              borderWidth: 1,
              borderColor: "#0DFFA9",
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1, //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: colorList[0].c1,
                  },
                  {
                    offset: 0.5,
                    color: colorList[0].c1,
                  },
                  {
                    offset: 1,
                    color: colorList[0].c2,
                  },
                ]
              ),
            },
          },
          lineStyle: {
            cap: 'round',
            width: 1,
            color: colorList[0].line
          },
          data: this.chartData.barList,
          areaStyle: {},
        });
        dataTime = this.chartData.regionList[0];
      }
      if(this.chartData.regionList) this.options.xAxis.data = this.chartData.regionList;
      this.options.series = series;
      this.chart.setOption(this.options);
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
  },
};
</script>
